<template>
  <div class="left cadfm-flexitem-fixed">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="toggleLeftPanel" icon="hide" bold :text="lang.button_Hide" :tooltip="lang.button_Hide"
            :disabled="false" />


        </b-navbar-nav>
      </action-bar>
      <action-content>
        <div class="Tabs">
          <b-tabs card>

            <b-tab :title="lang.Content.tab_BomDetails" :title-link-class="textColors" :title-item-class="textColors"
              active>
              <p>{{lang.Content.infotext_6}}:</p>
              <div class="list-details">
                <b-list-group>
                  <b-list-group-item>{{lang.Content.infotext_1}}: {{projectDetails.projectNumber}}</b-list-group-item>
                  <b-list-group-item>{{lang.Content.infotext_2}}: {{projectDetails.revision}}</b-list-group-item>
                  <b-list-group-item>{{lang.Content.infotext_8}}: {{projectDetails.projectType}}</b-list-group-item>
                  <b-list-group-item>{{lang.Content.infotext_9}}: {{projectDetails.projectOwner}}</b-list-group-item>
                  <b-list-group-item>{{lang.Content.infotext_7}}: {{bom.name}}</b-list-group-item>
                  <b-list-group-item>{{lang.Content.infotext_4}}: {{bom.Login}}</b-list-group-item>
                  <b-list-group-item>{{lang.Content.infotext_5}}: {{creationDate}}</b-list-group-item>
                  <b-list-group-item>{{lang.Content.infotext_3}}: {{bom.description}}</b-list-group-item>
                  <!-- <b-list-group-item v-if="currentUser.role != 'Reader'">
                    <b-form-checkbox :disabled="!bom.isBom||!isOwner"
                      id="isActiveCheckbox"
                      v-model="bom.isActive"
                      name="isActiveCheckbox"
                      value="true"
                      unchecked-value="false"
                    >
                      {{lang.Content.label_IsActive}}
                    </b-form-checkbox>
                    

                  </b-list-group-item> -->

                </b-list-group>
              </div>
              <!-- <p>{{lang.Content.infotext_1}}: </p>
              <p>  <span class="pm-part">{{selectedProjectRow.name}}</span></p>
              <hr>
              <p>{{lang.Content.infotext_2}}: </p>
              <p>  {{selectedProjectRow.revision}}</p>
              <hr>
              
              <p>{{lang.Content.infotext_4}}: </p>
              <p>  {{bom.Login}}</p>
              <hr>
              <p>{{lang.Content.infotext_5}}: </p>
              <p>  {{creationDate}}</p>
              <hr>
              <p>{{lang.Content.infotext_3}}: </p>
              <p class="descr-bom">  {{bom.description}}</p>
              <hr>
              <b-form-checkbox :disabled="!bom.isBom"
                id="isActiveCheckbox"
                v-model="bom.isActive"
                name="isActiveCheckbox"
                value="true"
                unchecked-value="false"
              >
                {{lang.Content.label_IsActive}}
              </b-form-checkbox> -->
            </b-tab>


          </b-tabs>

        </div>
      </action-content>
    </action-panel>

  </div>
</template>


<script>


import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import * as Tools from '../../../../../Tools/Tools'


export default {
  name: 'Left',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,

    
  },
  props:{
    lang: Object
  },
  data () {
    return {
      bom: {
        description: "",
        createDate: "",
        user: "",
        isActive: false,
        isBom: false,
        
      },
      projectDetails: {}
    }
  },
  computed: {
    ...mapGetters({

      selectedRows: 'selectedRows',
      selectedBomRow: 'selectedBomRow',
      currentUser: 'currentUser'
    }),
    creationDate(){
      
      if (this.bom.createDate == ""){
        return this.bom.createDate
      }
      return Tools.longDateToShort(this.bom.creationDate);
    },
    isOwner(){
      
      if (this.$store.getters.selectedRows.length == 0){
        return false;
      }
      return this.$store.getters.selectedRows[0].col___revisionId.userId == this.$store.getters.currentUser.userId;
    },
    // isActive(){
    //   return this.bom.isActive;
    // },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    routingObject() {
      if (this.$store.getters.routingData.length > 0) {
        return this.$store.getters.routingData[this.$store.getters.routingData.length - 1];
      }
      return;
    },
    bomId() {
      return this.$route.query.bomId;
    }
  },

  created() {
    this.reloadData();

  },
  watch: {
    bomId: function () {

      
      this.reloadData();

    }
        
  },
  
  methods: {
    reloadData() {


      let vue = this;

      let value = this.$route.query.id;


      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRevisionHistory', value);

      const obj = {
        bomId: this.bomId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getBom', obj)
        .then((result) => {

          console.log(result)
          if (result.status == "OK") {
            if (result.data != null) {
              vue.bom = result.data;
              vue.bom.isBom = true;

              vue.$store.dispatch(this.$store.getters.sectionPrefix + '_isBomInProject', true);
            } else {
              vue.$store.dispatch(this.$store.getters.sectionPrefix + '_isBomInProject', false);
              vue.bom.isBom = false;
            }

          }



        })
      let currentRevisionId = this.$route.query.currentRevisionId;
      if (this.$route.query.currentRevisionId == undefined) {
        currentRevisionId = this.$route.query.revisionId;
      }
      const objProj = {
        projectRevisionId: currentRevisionId//this.$store.getters.selectedRows[0].col___revisionId.revisionId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getProjectDetails', objProj)
        .then((result) => {

          console.log(result)
          if (result.status == "OK") {
            if (result.data != null) {



              vue.projectDetails = result.data;

            } else {

            }

          }



        })
    },
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>
  .left{
    border-right: 1px solid #666;
    min-width: 300px;
  }
  .descr-bom{
    word-wrap: break-word;
    max-width: 300px;
  }
  .pm-part{
    font-size: 20px;
  }
  .list-details{
    max-width: 300px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectBom/Left/Left.vue